<template>
  <div>
    <!-- <div id="content" class="colM">

      <h1>{{$t('registration.password_reset_done_title')}}</h1>

      <p>{{$t('registration.password_reset_done_c1')}}</p>

      <p>{{$t('registration.password_reset_done_c2')}}</p>

      <br class="clear">
    </div> -->
    <div>
      <div class="">
        <h2
          class="heading-w3-agile"
          style="text-align:center; color:black; font-weight: 200; text-transform: uppercase;"
        >
          {{ $t("registration.password_reset_done_title") }}
        </h2>
        <p class="heading-w3-agile" style="margin-bottom: 15px;">
          {{ $t("registration.password_reset_done_c1") }}
        </p>
        <p class="heading-w3-agile" style="margin-bottom: 15px;">
          {{ $t("registration.password_reset_done_c2") }}
        </p>
        <form>
          <label class="anim">
            <a @click="callbackLogin" style="color:black; cursor: pointer; padding-bottom: 15px;">{{
              $t("common.callBackLogin")
            }}</a>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'PasswordResetDone',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    callbackLogin: function() {
      this.$router.push({
        name: "Login"
      });
    },
    ...mapActions([]),
  },
  components: {
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
  }
}

</script>

<style lang="scss" scoped>
@import "../../styles/login_style.css";
@import "font-awesome/css/font-awesome.min.css";
h1 {
  margin: 0 0 20px;
  font-weight: 300;
  font-size: 20px;
  color: #666;
}

</style>


// WEBPACK FOOTER //
// src/views/Account/PasswordResetDone.vue